<template>
  <div class="checklist-page" style="margin-top: 10px">
    <card-custom
      class="d-flex flex-column"
      event_name="checklists"
      :show_dropdown_state="true"
      :dropdown_state="cardMessage.checklists"
      outlined
      style="border-radius: 0; border: 0px"
      v-if="checklistCategories !== undefined && checklistTables !== undefined"
    >
      <template v-slot:prepend_icon>
        <icon icon="tabler:checkup-list" height="24px" color="grey" />
      </template>

      <template v-slot:title>
        <div class="text-subtitle-2">{{ $t("_resultats_d_examen_") }}</div>
      </template>

      <template v-slot:teaser>
        <v-container class="d-flex flex-column px-0 py-0">
          <v-row justify="space-between">
            <v-col min-width="50%">
              <card-custom
                event_name="checklists"
                :show_dropdown_state="false"
                :dropdown_state="cardMessage.checklists"
                outlined
                elevation="0"
                style="width: 100%"
              >
                <template v-slot:prepend_icon>
                  <icon
                    :icon="checklistIcon['sysacq_trdata']['icon']"
                    :height="checklistIcon['sysacq_trdata']['height']"
                    :color="checklistIcon['sysacq_trdata']['color']"
                  />
                </template>

                <template v-slot:title>
                  <div class="title-with-status">
                    <div class="text-subtitle-3 title-text-truncate">
                      {{ $t(getChecklistCatDescription("sysacq_trdata")) }}
                    </div>
                    <checklist-status
                      :data="checklistStatus['sysacq_trdata']"
                    />
                  </div>
                </template>

                <template v-slot:content>
                  <v-container class="d-flex flex-column px-0 py-0">
                    <item-table
                      v-if="checklistTables !== undefined"
                      :key="checklist_key"
                      :datatable="checklistTables['sysacq_trdata']"
                      dense
                    />
                  </v-container>
                </template>
              </card-custom>
            </v-col>

            <v-col min-width="50%">
              <!-- Card_custom : net_env -->
              <card-custom
                event_name="checklists"
                :show_dropdown_state="false"
                :dropdown_state="cardMessage.checklists"
                outlined
                elevation="0"
                style="width: 100%"
              >
                <template v-slot:prepend_icon>
                  <icon
                    :icon="checklistIcon['net_env']['icon']"
                    :height="checklistIcon['net_env']['height']"
                    :color="checklistIcon['net_env']['color']"
                  />
                </template>
               
                <template v-slot:title>
                  <div class="title-with-status">
                    <div class="text-subtitle-3 title-text-truncate">
                      {{ $t(getChecklistCatDescription("net_env")) }}
                    </div>
                    <checklist-status
                      :data="checklistStatus['net_env']"
                    />
                  </div>
                </template>

                <template v-slot:content>
                  <v-container class="d-flex flex-column px-0 py-0">
                    <item-table
                      v-if="checklistTables !== undefined"
                      :key="checklist_key"
                      :datatable="checklistTables['net_env']"
                      dense
                    />
                  </v-container>
                </template>
              </card-custom>
            </v-col>
          </v-row>

          <v-row justify="space-between">
            <v-col min-width="50%">
              <!-- Card_custom : inv -->
              <card-custom
                event_name="checklists"
                :show_dropdown_state="false"
                :dropdown_state="cardMessage.checklists"
                outlined
                elevation="0"
                style="width: 100%"
              >
                <template v-slot:prepend_icon>
                  <icon
                    :icon="checklistIcon['inv']['icon']"
                    :height="checklistIcon['inv']['height']"
                    :color="checklistIcon['inv']['color']"
                  />
                </template>

              
                <template v-slot:title>
                  <div class="title-with-status">
                    <div class="text-subtitle-3 title-text-truncate">
                      {{ $t(getChecklistCatDescription("inv")) }}
                    </div>
                    <checklist-status
                      :data="checklistStatus['inv']"
                    />
                  </div>
                </template>

                <template v-slot:content>
                  <v-container class="d-flex flex-column px-0 py-0">
                    <item-table
                      v-if="checklistTables !== undefined"
                      :key="checklist_key"
                      :datatable="checklistTables['inv']"
                      dense
                    />
                  </v-container>
                </template>
              </card-custom>
            </v-col>

            <v-col min-width="50%">
              <!-- Card_custom : field_mod -->
              <card-custom
                event_name="checklists"
                :show_dropdown_state="false"
                :dropdown_state="cardMessage.checklists"
                outlined
                elevation="0"
                style="width: 100%"
              >
                <template v-slot:prepend_icon>
                  <icon
                    :icon="checklistIcon['field_mod']['icon']"
                    :height="checklistIcon['field_mod']['height']"
                    :color="checklistIcon['field_mod']['color']"
                  />
                </template>

                <template v-slot:title>
                  <div class="title-with-status">
                    <div class="text-subtitle-3 title-text-truncate">
                      {{ $t(getChecklistCatDescription("field_mod")) }}
                    </div>
                    <checklist-status
                      :data="checklistStatus['field_mod']"
                    />
                  </div>
                </template>
                

                <template v-slot:content>
                  <v-container class="d-flex flex-column px-0 py-0">
                    <item-table
                      v-if="checklistTables !== undefined"
                      :key="checklist_key"
                      :datatable="checklistTables['field_mod']"
                      dense
                    />
                  </v-container>
                </template>
              </card-custom>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </card-custom>
  </div>
</template>

<script>
import api from "@/api/api";
import { Icon } from "@iconify/vue2";
import ItemTable from "../../../components/UI_kit/ItemTable.vue";
import ChecklistStatus from "../../../components/UI_kit/ChecklistStatus.vue";
import CardCustom from "../../../components/UI_kit/CardCustom.vue";

export default {
  components: {
    Icon,
    ItemTable,
    ChecklistStatus,
    CardCustom,
  },
  props: {
    selected_date: {
      type: String,
      required: true,
    },
    checklistStatusdict: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      datePicked: this.getAuditEndDate(),
      cardMessage: {
        indicator: false,
        alarm: true,
        checklists: false,
        sysacq_trdata: false,
        net_env: false,
        inv: false,
        field_mod: false,
      },
      checklistCategories: [],
      checklistIcon: {},
      checklistStatus: {},
      checklistTables: {},
      checklist_key: 0,
    };
  },

  mounted() {
    this.getChecklistCategories();
    this.getChecklists();
    this.getChecklistStatus();
    this.getChecklistIcon();
  },
  watch: {
    selected_date: {
      handler() {
        this.getChecklistCategories();
        this.getChecklists();
        this.getChecklistStatus();
        this.getChecklistIcon();
      },
      immediate: true,
      deep: true,
    },
    $route: {
      handler() {
        this.getChecklistCategories();
        this.getChecklists();
        this.getChecklistStatus();
        this.getChecklistIcon();
      },
      immediate: true,
      deep: true,
    },
    checklistStatusdict: {
      handler() {
        this.getChecklistCategories();
        this.getChecklists();
        this.getChecklistStatus();
        this.getChecklistIcon();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    getAuditEndDate() {
      return this.$store.state.parametersStore.audit_dates.end;
    },

    getChecklistCategories() {
      if (this.$store.getters.lang_code !== undefined) {
        api.getChecklistCategories().then((res) => {
          this.checklistCategories = res.data;
        });
      }
    },

    getChecklistCatDescription(cat_code) {
      if (this.checklistCategories !== undefined && cat_code !== undefined) {        
        return this.checklistCategories[cat_code];
      }
    },

    getChecklistIcon() {
      this.$store.getters.constants["alarm"].forEach((checklist) => {        
        this.checklistIcon[checklist.key] = checklist["icon"];
      });
    },

    async getChecklists() {
      if (this.$store.getters.cur_install_id !== undefined) {
        await api
          .getChecklists(this.$store.getters.cur_install_id, this.selected_date)
          .then((res) => {
            this.checklistTables = res.data;
            this.checklist_key++;
          });
      }
    },

    getChecklistStatus() {
      this.checklistStatus = this.checklistStatusdict;
    },
  },
};
</script>

<style>
.checklist-page
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  height: 32px !important;
  padding: 4px 6px !important;
}

.checklist-page .v-data-table-header th {
  height: 28px !important;
  padding: 2px 6px !important;
}

#sys_acq > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#env_res > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#inv > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#field_mod > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#alm_inc > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2) {
  height: 20px;
  vertical-align: middle;
  padding: 2px 6px;
  background-color: #f7f7f7;
}

.text-subtitle-3 {
  font-size: 0.775rem !important;
  font-weight: 300;
  line-height: 0.5rem;
  letter-spacing: 0.0071428571em !important;
  font-family: Roboto, sans-serif !important;
  color: grey;
}

.text-subtitle-2 {
  font-size: 0.8rem !important;
  line-height: 1rem !important;
}
.v-container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.v-row {
  margin: 0 !important;
  row-gap: 2px !important; /* reduces space between rows */
}

.v-col {
  padding: 2px !important; /* less space around columns */
}

.card-custom {
  padding: 4px !important;
  margin-bottom: 4px !important;
}

.card-custom .v-card__text {
  padding: 4px !important;
}

.title-with-status {
  display: flex;
  align-items: center;
  width: 100%;
}

.title-text-truncate {
  flex: 1;                  /* takes remaining space */
  white-space: nowrap;       /* prevent wrapping */
          /* hide overflow */
  text-overflow: ellipsis;   /* add ... if too long */
}
.title-text-truncate {
  margin-right: 20px; /* small spacing, adaptive */
}


</style>
